let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9qj4A")).then(() => parcelRequire('jGoOG'));